import Vue from 'Vue'
import types from './types';
import { getClaim } from './../../../utils/cognito';

const getGroups = () => {
  try {
    const groups = getClaim('cognito:groups')
    return groups;
  } catch (err) {
    return [];
  }
}

export default {
  authRequest: (state) => {
    state.status = 'loading'
  },
  authSuccess: (state, session) => {
    console.log('Mutation authSuccess');
    console.dir(session);

    state.status = 'success'
    state.session = session
    state.idToken = session.getIdToken().getJwtToken();
    state.cognitoGroups = getGroups();
  },
  authError: (state) => {
    state.status = 'error'
  },
  authLogout: (state) => {
    state.session = undefined
    state.idToken = ''
    state.cognitoGroups = []
  },
  [types.mutations.REGISTERING_USER]: (state) => {
    state.register.status = 'pending'
  },
  [types.mutations.USER_REGISTERED]: (state) => {
    state.register.status = 'done'
  },
  [types.mutations.REGISTERING_USER_FAILED]: (state) => {
    state.register.status = 'failed'
  },
  [types.mutations.GENERATING_CODES]: (state) => {
    console.log('GENERATING_CODES_MUTATION');
    state.codes.status = 'pending'
  },
  [types.mutations.RECEIVE_CODES]: (state, codes) => {
    console.log('RECEIVE_CODES', codes);
    state.codes.status = 'done'
    Vue.set(state.codes, 'data', codes);
  },
  [types.mutations.CODE_GENERATION_ERROR]: (state, error) => {
    console.log('CODE_GENERATION_ERROR', error);
    state.codes.status = 'error'
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js